import styled from 'styled-components';
import LoadDetailsSide from './LoadDetailsSide';
import { colorSchema } from 'utils/style';

export default styled(LoadDetailsSide)`
  .load-details-side {
    display: flex;
    flex-direction: column;

    &__row {
      display: flex;
      margin-bottom: 1.8rem;

      &--wrap {
        flex-wrap: wrap;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &__item {
      flex-grow: 1;
    }

    &__label {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      line-height: 1.5;
    }

    &__quantity {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      font-weight: 500;
    }

    &__extra {
      margin-bottom: 0.8rem;
      margin-right: 0.8rem;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
`;
